import React from 'react';
import { CtaButton } from '../ui/CtaButton';
import { SectionLabel } from '../ui/SectionLabel';
export function UrgencyBanner() {
  return <section aria-labelledby="urgencia-title" className="w-full bg-pitch" data-id="element-229" data-mp="238z9f25ibtjb">
      <div className="mx-auto flex max-w-3xl flex-col items-center px-5 py-16 text-center md:py-20" data-id="element-230" data-mp="2hx3rq50ne31k">
        <SectionLabel tone="gold" data-id="element-231" data-mp="2d4k4shg2lvk3">Oferta sólo por hoy</SectionLabel>
        <h2 id="urgencia-title" className="mt-5 font-display text-3xl font-black leading-tight text-white md:text-4xl" data-id="element-232" data-mp="2qwgwwlhqo5gh">
          Este precio es solo por hoy
        </h2>
        <p className="mt-4 max-w-xl text-base text-body" data-id="element-233" data-mp="30vg4s1uojx2f">
          Mañana el precio sube y el paquete con los dos bonos deja de estar disponible a este
          valor.
        </p>
        <div className="mt-8" data-id="element-234" data-mp="16gvoe1de6nou">
          <CtaButton size="xl" data-id="element-235" data-mp="16g3tksrmctzm">Aprovechar la oferta</CtaButton>
        </div>
      </div>
    </section>;
}